import { checkEmptyFields } from '../utils';
import { EventProperties } from '@lentau/analytics/health-metrics/shared';
import { CategoryItemProps } from '@lentau/product/shared/interfaces';
import { GoodsCategoriesTreeByChildResponse } from '@lentau/catalog/entities';

export function getCategoryHandler(body: GoodsCategoriesTreeByChildResponse): EventProperties {
  {
    const categories: CategoryItemProps[] = body.GoodsCategoryList;

    const fields = categories
      .map((category: CategoryItemProps) => {
        return [
          {
            fieldToCheck: category.Name,
            errorName: 'categoryNameEmpty',
          },
          {
            fieldToCheck: category.ImageUrl,
            errorName: 'categoryImageEmpty',
          },
        ];
      })
      .flat();

    return checkEmptyFields(fields);
  }
}
